
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/template/[slug]",
      function () {
        return require("private-next-pages/template/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/template/[slug]"])
      });
    }
  